module.exports = __webpack_public_path__ + "img/21_71.77c52dc0.png";